module.exports = __webpack_public_path__ + "static/media/02.e4fa8f72.jpg";